import React, { useEffect } from 'react';
import Banner from './banner';
import Welcome from './welcome';
import Theme from './theme';
import Speakers from './speakers';
import Dates from './dates';
import { homeContent2024 } from './content';

function Home({ content }) {
  const pageContent = content || homeContent2024;
  
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <React.Fragment>
      <Banner content={pageContent.banner} />
      <Welcome content={pageContent.welcome} />
      <Theme content={pageContent.theme} />
      <Speakers content={pageContent.speakers} />
      <Dates content={pageContent.dates} />
    </React.Fragment>
  )
}

export default Home